<template>
  <el-dialog title="创建面试" :visible.sync="dialogVisible" width="40%" :before-close="onClose">
    <div style="line-height: 30px; text-align:left">
      <el-row>
        <el-col :span="4">
          <user-avatar :src="headImage" class="useravatar-cicle-m"></user-avatar>
        </el-col>
        <el-col :span="20">
          <div>{{meName}}</div>
          <div>
            <span v-if="degree">{{degree}}<el-divider direction="vertical"></el-divider></span>
            {{workYear}} 年经验
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          面试公司：
        </el-col>
        <el-col :span="20">{{companyName}}</el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          面试职位：
        </el-col>
        <el-col :span="20">{{postName}}</el-col>
      </el-row>
    </div>
    <el-form ref="createForm" style="margin-top: 16px; text-align: left;" :model="form" :rules="rules" label-width="110px">
      <el-form-item label="面试联系人：" prop="hrName">
        <el-input v-model="form.hrName"></el-input>
      </el-form-item>
      <el-form-item label="联系人手机：" prop="hrMobile">
        <el-input v-model="form.hrMobile"></el-input>
      </el-form-item>
      <el-form-item label="面试时间：" prop="interviewTime">
        <el-date-picker v-model="form.interviewTime" type="datetime" placeholder="选择日期时间" default-time="10:00:00"
          format="yyyy-MM-dd HH:mm">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="面试地点：" prop="interviewPlace">
        <el-input v-model="form.interviewPlace"></el-input>
      </el-form-item>
      <el-form-item label="注意事项：">
        <el-input v-model="form.interviewNote"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="onClose">取 消</el-button>
      <el-button type="primary" :loading="loading" @click="onConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import userAvatar from '~/components/UserAvatar';
  import {
    basicInfo,
    lastInterviewInfo,
    createReinterview
  } from '~/api/interview';
  import {
    isMobile
  } from '~/utils/validate';
  export default {
    components: {
      userAvatar
    },
    props: {
      visible: false,
      interviewId: 0,
    },
    watch: {
      visible(val) {
        this.dialogVisible = val;
      },
      interviewId(val) {
        this.getInterviewBasicInfo();
        this.getLastInterviewInfo();
      }
    },
    data() {
      return {
        dialogVisible: false,
        meName: '',
        headImage: '',
        degree: '',
        workYear: 0,
        companyName: '',
        postName: '',
        loading: false,
        form: {
          hrName: '',
          hrMobile: '',
          interviewTime: '',
          interviewPlace: '',
          interviewNote: '',
        },
        rules: {
          hrName: [{
            required: true,
            message: '请输入人事姓名',
            trigger: 'blur'
          }, ],
          hrMobile: [{
            required: true,
            message: '请输入人事手机',
            trigger: 'blur'
          }, {
            validator: isMobile,
            trigger: 'blur'
          }],
          interviewTime: [{
            type: 'date',
            required: true,
            message: '请选择日期',
            trigger: 'change'
          }],
          interviewPlace: [{
            required: true,
            message: '请输入面试地点',
            trigger: 'blur'
          }]
          // interviewNote: [
          //   { required: true, message: '请输入注意事项', trigger: 'blur' }
          // ]
        }
      }
    },
    created() {
      this.getInterviewBasicInfo();
      this.getLastInterviewInfo();
    },
    methods: {
      getInterviewBasicInfo() {
        var params = {
          interviewId: this.interviewId
        };
        basicInfo(params).then(r => {
          if (r.errcode === 0) {
            let data = r.data;
            if (data) {
              this.meName = data.meName;
              this.headImage = data.headImage;
              this.degree = data.degree;
              this.workYear = data.workYear;
              this.companyName = data.companyName;
              this.postName = data.postName;
            }
          }
        });
      },
      getLastInterviewInfo() {
        var params = {
          interview_id: this.interviewId
        };
        lastInterviewInfo(params).then(r => {
          if (r.errcode === 0) {
            var data = r.data;
            if (data) {
              this.form.hrName = data.interviewer;
              this.form.hrMobile = data.interviewphone;
              this.form.interviewPlace = data.interviewplace;
            }
          }
        })
      },
      onClose() {
        this.$emit('close');
      },
      onConfirm() {
        this.$refs['createForm'].validate((valid) => {
          if (valid) {
            this.loading = true;
            var params = {
              interview_id: this.interviewId,
              interview_time: this.$Shared.formatDateTime(this.form.interviewTime),
              companyname: this.companyName,
              viewpost: this.postName,
              interviewer: this.form.hrName,
              interviewphone: this.form.hrMobile,
              interviewplace: this.form.interviewPlace,
              interviewnote: this.form.interviewNote
            };
            createReinterview(params).then(m => {
              this.loading = false;
              let errcode = m.errcode;
              if (errcode == 0) {
                this.$message.success('面试生成成功');
                this.$emit('success', this.interviewId);
              } else {
                this.$message.error('面试生成失败, 原因：' + m.errmsg);
              }
            });
          } else {
            return false;
          }
        });
      }
    }
  }
</script>

<style scoped>

</style>